<template>
  <div>
    <p>
      Dated this <span class="underline">{{ date }}</span> day of
      <span class="underline">{{ month }}</span> {{ year }}.
    </p>
  </div>
</template>

<script>
const MONTH = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
// 1st, 2nd... 20th, 21st... 31st
const ordinal = ["th", "st", "nd", "rd"];

export default {
  name: "FormPFDS",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      date: "",
      month: "",
      year: "",
    };
  },
  mounted() {
    const curr = new Date();
    this.year = curr.getFullYear();
    this.month = MONTH[curr.getMonth()];
    const date = curr.getDate();
    if (date % 20 <= 3) {
      this.date = date + ordinal[date % 20];
    } else {
      this.date = date + ordinal[0];
    }
  },
};
</script>

<style scoped>
.underline {
  display: inline;
  border-bottom: 1px solid #000;
  padding: 0 8px;
}
</style>